import {React,useEffect,useState,useContext} from 'react'
import axios from "axios";
import { GlobalLoading, showLoading } from 'react-global-loading';
import { MyContextProvider } from "../../../App";
import {API_URL}  from '../../../Constant';
import {generateExcel} from '../../../Custom/ExportExcel';
import {changeDateFormat,shortMonthToFull,validateRoles} from "../../../Custom/Custom";
import titlesData from '../../../titles.json';
import { jwtDecode } from 'jwt-decode';
import { useNavigate } from "react-router-dom";

function NewPendencyReport() {

  const currentDate = new Date();
  const prevMonthDate = new Date(currentDate);
  prevMonthDate.setMonth(currentDate.getMonth() - 1);
  const prevMonthName = prevMonthDate.toLocaleString('default', { month: 'short' }).toUpperCase();

  const [years,setYears]=useState([]);
  const [yearName,setyearName]=useState(new Date().getFullYear());
  const [months,setMonth]=useState([]);
  const [monthName,setMonthName]=useState(prevMonthName);
  const token=useContext(MyContextProvider).token;
  const navigate = useNavigate();

  const config = {
      headers: {
          Authorization: `Bearer ${token}`,
      },
    };
    


useEffect(() => { //Get all Years Data

   //Years
      const fetchYears = async () => {


        const decodedToken = jwtDecode(token);
        const role = await validateRoles(decodedToken);
  
        if (!role) {
          alert("You are not an authorized user to capture the data for Pricing");
          navigate("/dashboard");
          return;
        }

      showLoading(true)
      const currentYear = new Date().getFullYear();
      const endYear = 2021;
      const yearsArray = [];

      for (let year = currentYear; year >= endYear; year--) {
        yearsArray.push(year);
      }

      setYears(yearsArray);
    
  axios
     .get(`${API_URL}api/graph/getMonths/2019`,config)
          .then((res) => {
            let monthDataResponse=res.data;
            if(monthDataResponse.status){
                setMonth(monthDataResponse.data);
                
              }
              showLoading(false)
         })
          .catch((err) =>{
            console.log(err)
            showLoading(false)
          });
        }

      fetchYears();
       
          
}, []);
  

    const handleSubmit=(e)=>{
       showLoading(true)

     const excelObjectData = {
        fileName: "Price_PendencyReportNew",
        reportType: "Price_PendencyReportNew",
        fileType:'xls',
        sheetName:"PricePendency",
        firstRowMergeCells:"A1:V1",
        firstRowText:"New Pendency Report",
        firstRowExportDate:changeDateFormat(new Date()),
        firstRowCellNumber:13,
        secondRowMergeCells:"A2:V2",
        secondRowText:`${monthName}-${yearName}`,
        secondRowExportDate:changeDateFormat(new Date()),// not require
        secondRowCellNumber:13,// not require
        headerEnglishColumns:  [
          'Division', 'District', 'Urban Consumer Price Input Form', 'Scrutiny',
          'Rural Consumer Retail Price', 'Scrutiny', 'Whole Sale Price',
          'Scrutiny', 'Urban Labour Wages Rates',
          'Scrutiny', 'Rural Labour Wages Rates (For Men)', 'Scrutiny',
          'Rural Labour Wage Rates (For Women)','Scrutiny','Retail Price For Necessary Items Lucknow',
          'Scrutiny','Whole Sale Raw Wool Price','Scrutiny','Whole Sale Kanpur District','Scrutiny',
          'Whole Sale Price For Agriculture Items of Hapur Mandi','Scrutiny'
        ],
        headerHindiColumns: [
          'मण्डल', 'जिला', 'नगरीय उपभोक्ता मूल्य इनपुट फार्म', 'A/R Date',
          'ग्रामीण उपभोक्ता खुदरा मूल्य', 'A/R Date', 'थोक मूल्य',
          'A/R Date', 'नगरीय श्रम मज़दूरी दर',
          'A/R Date', 'ग्रामीण श्रम मज़दूरी दर ( पुरूषो के लिए )', 'A/R Date',
          'ग्रामीण श्रम मज़दूरी दर (स्त्रियो के लिए)','A/R Date','लखनऊ आवश्यक वस्तुओं के लिए फुटकर मूल्य'
          ,'A/R Date','थोक मूल्य कच्चे ऊन','A/R Date','थोक मूल्य कानपुर जिला','A/R Date','हापुड़ मंडी के थोक मूल्य कृषि  वस्तुएँ',
          'A/R Date'
        ],
        excelRowData:[  // added data after get
             ]
      };
      
      
      let postData= {
        "monthInChar":monthName,
        "year": yearName,
      }
      
     axios
      .post(`${API_URL}api/price/getNewpendencyreport`,postData,config)
           .then((res) => {

             let pendencyDataResponse = [...(res.data.data[0].GroupCodes || [])].sort((a, b) => {
              const divDiff = Number(a.DIVISION_CODE) - Number(b.DIVISION_CODE);
              if (divDiff !== 0) return divDiff;
              return Number(a.DISTRICT_CODE) - Number(b.DISTRICT_CODE);
             });
             const transformedData = pendencyDataResponse.map(item => [
              `${item.DIVISION_NAME}(${item.DIVISION_CODE})` || 'NA',
              `${item.DISTRICT_NAME}(${item.DISTRICT_CODE})` || 'NA',
              item.urban_submit_dt || 'NA',
              item.urban_scrutiny || '',
              item.rural_submit_dt || 'NA',
              item.rural_scrutiny || '',
              item.ws_submit_dt || 'NA',
              item.wholesale_scrutiny || '',
              item.urbn_wage_submit_dt || 'NA',
              item.Urban_Wage_scrutiny || '',
              item.ruralmen_wage_submit_dt || 'NA',
              item.Rural_Wage_Men_scrutiny || '',
              item.ruralwomen_wage_submit_dt || 'NA',
              item.Rural_Wage_Women_scrutiny || '',
              item.ss_submit_dt || 'NA',
              item.necessary62_scrutiny || '',
              item.ws_raw_submit_dt || 'NA',
              item.Whole_Sale_Raw_Wool_scrutiny || '',
              item.ws_kanpur_submit_dt || 'NA',
              item.Whole_Sale_Kanpur_scrutiny || '',
              item.ws_agri_submit_dt || 'NA',
              item.Whole_Sale_Hapur_scrutiny || '',

             ]);
            excelObjectData.excelRowData=transformedData;
            generateExcel(excelObjectData)
            showLoading(false)
             })
           .catch((err) =>{ 
            console.log(err)
            showLoading(false)
           });
           
    }

    const storedLanguage = localStorage.getItem('language');

  return (
    <>
   
    <GlobalLoading />

 <div className="container-fluid py-3">
     <div className="card mx-3 mb-3">
        <div className="card-body pb-1">
          <div className="row align-items-center">
           <h4 className="page_heading"><span className="text_orange"> Price Wages Indices System Accept Reject Status</span> New Pendency Report</h4>
            <div className="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-6 mb-3">
                <label>Month</label>
                
                <select value={monthName} onChange={(e)=>(setMonthName(e.target.value))} name="month_name" className="form-select">
                  <option value="" disabled>Select Month</option>
                  {months && months.map((ele,i)=>(
                    <option key={i} value={ele.MONTH}>{shortMonthToFull(ele.MONTH)}</option>
                  ))

                  }
                </select>
                
            </div>
            
            <div className="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-6 mb-3">
                <label>Year</label>
                <select value={yearName} onChange={(e)=>(setyearName(e.target.value))} name="year_name"  className="form-select" >
                  <option value="" disabled >Select Year</option>
                  {years.map((ele, index) => (
                    <option key={index} value={ele}>
                      {ele}
                    </option>
                  ))}

              </select>
            </div>
         
         <div className="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-12 mb-3">
             <label className="w-100 d-none d-sm-block">&nbsp;</label>
             <button onClick={handleSubmit} type="submit" className="btn btn_orange">Get Data</button>
         </div>
        </div>
      </div> 
     </div>
    
</div>
 
 </>
  )
}

export default NewPendencyReport